<template>
  <div>
    <div class="container">
      <div class="row">
        <div
          class="card-body"
          :style="{ padding: $mq !== 'sm' ? '3rem' : '1rem' }"
        >
          <div class="CTA" style="min-height:0">
            <h3>
              {{ $t("Verifica il tuo numero di cellulare") }}
            </h3>
            <h5 class="mb-0" v-if="sentCode">
              {{
                $t(
                  "Ti abbiamo inviato un SMS con il codice per la verifica del numero"
                )
              }}
              <br />
              <strong x-ms-format-detection="none">{{
                toBeVerifiedNumber
              }}</strong>
            </h5>
          </div>
          <form
            class="mt-5 row"
            style="padding-left:15px;padding-right:15px;"
            data-vv-scope="confirmationForm"
            @submit.prevent="validateForm('confirmationForm', callbackForm)"
            v-cloak
          >
            <div class="form-group col-12 p-0">
              <div v-if="sentCode">
                <div class="pl-3 pr-3 form-group">
                  <input
                    id="confirmation"
                    type="text"
                    class="form-control $errors->has('confirmation') ? ' is-invalid' : '' }}"
                    name="confirmation"
                    required
                    :placeholder="$t('Codice di conferma')"
                    v-validate="'required'"
                    v-model="confirmationCode"
                  />
                  <label for="confirmation" class="h5">{{
                    $t("Codice di conferma")
                  }}</label>
                  <span
                    v-show="errors.has('confirmationForm.confirmation')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>{{
                      errors.first("confirmationForm.confirmation")
                    }}</strong>
                  </span>
                </div>
              </div>
              <div v-else>
                <div class="pl-3 pr-3 form-group">
                  <input
                    name="number"
                    type="text"
                    class="form-control"
                    id="number"
                    :placeholder="$t('Inserisci il tuo numero')"
                    v-model="toBeVerifiedNumber"
                    v-validate="'required|phone'"
                  />
                  <label for="mobile-number" class="h5">{{
                    $t("Inserisci il tuo numero")
                  }}</label>
                  <span
                    v-show="errors.has('confirmationForm.number')"
                    class="invalid-feedback"
                    style="position: relative; bottom: 0px; padding-bottom: 10px;"
                  >
                    <strong>{{
                      errors.first("confirmationForm.number")
                    }}</strong>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="row"
              style="width:100%"
              :style="{
                'margin-top': $mq !== 'sm' && $mq !== 'md' ? '89px' : '0'
              }"
            >
              <div
                v-if="sentCode"
                class="col-12 col-lg-6 text-center text-lg-left"
                style="line-height:48px"
              >
                <small>{{ $t("Non hai ricevuto il codice?") }}</small>
                <a
                  class="c-form-actions__link btn-not-spinner"
                  href="#"
                  @click="resendVerifyCode"
                  >{{ $t("Reinvia") }}</a
                >
              </div>

              <div
                v-if="sentCode"
                class="form-group col-12 col-lg-6 text-center text-lg-right"
                style="padding-top: 0"
              >
                <button class="btn btn-primary btn-lg">
                  {{ $t("Conferma") }}
                </button>
              </div>
              <div v-else class="form-group col-12 col-lg-6">
                <button class="btn btn-primary btn-lg">
                  {{ $t("Invia") }}
                </button>
              </div>
            </div>
          </form>
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "verify-mobile",
  data() {
    return {
      confirmationCode: "",
      toBeVerifiedNumber: null,
      sentCode: false
    };
  },
  methods: {
    async sendVerifyCode() {
      this.$store.commit("showSpinner");

      try {
        let response = await this.$http.post(
          "api/v1/campaigns/" + this.$store.state.campaign.id + "/mobile",
          {
            mobile: this.toBeVerifiedNumber
          }
        );
        this.sentCode = true;
      } catch (error) {
        let errorResponse = error.response;
        switch (errorResponse.status) {
          case 422:
            this.$store.commit("pushMessage", {
              type: "waiting",
              title: this.$i18n.t("Dati non validi"),
              text: this.$i18n.t("Riprovare per favore")
            });
            break;
          case 406:
            this.sentCode = true;
            break;
          case 409:
            this.$store.commit("pushMessage", {
              type: "error",
              title: this.$i18n.t("Errore"),
              text: this.$i18n.t("Numero di telefono già verificato")
            });
            break;
          default:
            this.$store.commit("pushMessage", {
              type: "error",
              title: this.$i18n.t("Errore"),
              text: this.$i18n.t("Si è verificato un errore")
            });
            break;
        }
      }
      this.$store.commit("hideSpinner");
    },
    async resendVerifyCode() {
      this.$store.commit("showSpinner");

      try {
        let response = await this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/mobile/resendVerify",
          {
            mobile: this.toBeVerifiedNumber
          }
        );
      } catch {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async verifyCode() {
      this.$store.commit("showSpinner");

      try {
        let response = await this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/mobile/verify",
          {
            mobile: this.toBeVerifiedNumber,
            verify_code: this.confirmationCode
          }
        );

        this.$router.push("/");
      } catch {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    callbackForm() {
      if (this.sentCode) {
        return this.verifyCode();
      }

      return this.sendVerifyCode();
    }
  }
};
</script>
